export enum Scene {
  UserRegister   = 'user_register',
  UserForget     = 'user_forget',
  UserBindMobile = 'user_bind_mobile',
}
